import { TYPE_STRING } from './input-types';

export const id = 'buyerId';
export const apiKey = 'BuyerId';
export const type = TYPE_STRING;

export const buyerId = {
  id,
  apiKey,
  type,
};
